import { render, staticRenderFns } from "./adminProfile.vue?vue&type=template&id=72f5eba2&scoped=true"
import script from "./adminProfile.vue?vue&type=script&lang=js"
export * from "./adminProfile.vue?vue&type=script&lang=js"
import style0 from "./adminProfile.vue?vue&type=style&index=0&id=72f5eba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f5eba2",
  null
  
)

export default component.exports